export default __webpack_public_path__ + "static/media/homepage-trainer.b2247ac6.png";